<template>
  <div class="p-2" :data-update="update">
    <h1>{{ $schema[table].title_single }}: {{ record[$schema[table].list_field] }} <a
        @click="$refs.modal_history.active = true"><i class="las la-book"></i> Napló</a></h1>
    <router-link :to="'/list/' + table + '/#scroll-' + this.$route.params.id"><i class="las la-arrow-left"></i> {{
      $schema[table].title
    }}</router-link>
    <br />
    <div v-if="loading" class="w-screen">
      <div class="w-32 h-32 text-primary"
        style="position: absolute; opacity: 0.2; top: 50%; left: 50%; margin-left: -4rem; margin-top: -4rem">
        <svg class="w-32 h-32 animate-spin" viewBox="0 0 32 32">
          <path
            d="M 18 4.179688 L 18 6.203125 C 22.558594 7.132813 26 11.171875 26 16 C 26 21.515625 21.515625 26 16 26 C 10.484375 26 6 21.515625 6 16 C 6 11.171875 9.441406 7.132813 14 6.203125 L 14 4.179688 C 8.335938 5.136719 4 10.066406 4 16 C 4 22.617188 9.382813 28 16 28 C 22.617188 28 28 22.617188 28 16 C 28 10.066406 23.664063 5.136719 18 4.179688 Z" />
        </svg>
      </div>
    </div>
    <div v-if="!loading && record">
      <Form :form="editForm()" @input="editInput" classes="w-full grid grid-cols-3 gap-4" :value="editValue"
        @submit="submit" />
      <div class="flex justify-end w-full px-2 py-4">
        <button @click="submit" class="p-2 px-8 text-2xl font-bold text-white rounded-md bg-primary"> <i
            class="las la-save"></i> Mentés </button>
      </div>
      <br>
    </div>
    <template v-if="table == 'orders' && !loading && record">
      <div v-if="record.item.settings.product == 'businesscard'" style="user-select: text;" class="my-4">
        <div v-for="(page, p) in record.item.pages" :key="p" class="p-1 border-t border-black">
          <h3>{{ ['A', 'B'][page.number] }} oldal:</h3>
          <template v-if="page.template.name == 'empty'">
            Üres
          </template>
          <template v-if="page.template.name == 'cal1'">
            QR kód
          </template>
          <template v-if="page.template.name == 'cal1' || page.template.name == 'cal2'">
            Naptár
          </template>
          <template
            v-if="parseInt(page.template.name) > 0 || page.template.name == 'notes1' || page.template.name == 'notes2'">
            Nyomtatott méret: <b>{{ page.template.w }}x{{ page.template.h }}mm, {{ page.template.bleed }}mm kifutó.</b>
            Vágott méret: <b>{{ page.template.w - page.template.bleed * 2 }}x{{
              page.template.h - page.template.bleed *
                2
            }}mm.</b><br><br>
            Sablon mérete (szerkesztett méret): <b>{{ page.template.originalW }}x{{ page.template.originalH }}mm, {{
              page.template.bleed
            }}mm kifutó</b><br>
            <div class="flex">
              <div class="pt-4 pr-4">
                Sablon: <b :set="bim = page.template.layers.background_image">#{{ page.template.name }}</b><br>
                <a v-if="bim" :href="bim.image.url" target="_blank" title="Kép új ablakban">
                  <img :src="bim.image.pvUrl" class="w-48 h-auto">
                </a><br>
              </div>
              <div class="pt-4 pr-4">
                Háttérkép cseréje ({{ page.template.originalW }}x{{ page.template.originalH }}mm, 600 DPI, .png): <input
                  type="file" class="w-96"
                  @change="imageUpload('item.pages.' + page.number + '.template.layers.background_image.image', page.number, $event)">
                <div v-if="bimPlace[page.number]">
                  <img :src="bimPlace[page.number]" class="w-48 h-auto">
                </div>
              </div>
            </div>
            <div v-for="(fname, fkey) in textFields" :key="fkey" class="flex pb-1">
              <div class="w-24 p-1">{{ fname }}:</div>
              <input type="text" size="4" class="w-16"
                :value="editValue('item.pages.' + page.number + '.template.layers.' + fkey + '.size')"
                @input="editInputNumber({ field: 'item.pages.' + page.number + '.template.layers.' + fkey + '.size', value: $event.target.value })"
                @change="editInputNumber({ field: 'item.pages.' + page.number + '.template.layers.' + fkey + '.size', value: $event.target.value })">
              <div class="p-1">pt &nbsp; Szín:</div>
              <input type="text" size="4" class="w-32"
                :value="editValue('item.pages.' + page.number + '.template.layers.' + fkey + '.color')"
                @input="editInput({ field: 'item.pages.' + page.number + '.template.layers.' + fkey + '.color', value: $event.target.value })"
                @change="editInput({ field: 'item.pages.' + page.number + '.template.layers.' + fkey + '.color', value: $event.target.value })">
              <div class="w-24 p-1">&nbsp; Pozíció v:</div>
              <input type="text" size="4" class="w-20"
                :value="editValue('item.pages.' + page.number + '.template.layers.' + fkey + '.x')"
                @input="editInputNumber({ field: 'item.pages.' + page.number + '.template.layers.' + fkey + '.x', value: $event.target.value })"
                @change="editInputNumber({ field: 'item.pages.' + page.number + '.template.layers.' + fkey + '.x', value: $event.target.value })">
              <div class="p-1">mm &nbsp; f:</div>
              <input type="text" size="4" class="w-20"
                :value="editValue('item.pages.' + page.number + '.template.layers.' + fkey + '.y')"
                @input="editInputNumber({ field: 'item.pages.' + page.number + '.template.layers.' + fkey + '.y', value: $event.target.value })"
                @change="editInputNumber({ field: 'item.pages.' + page.number + '.template.layers.' + fkey + '.y', value: $event.target.value })">
              <div class="w-24 p-1">mm &nbsp; Font:</div>
              <Select classes="w-72" :options="fontOptions"
                :value="fontOption(editValue('item.pages.' + page.number + '.template.layers.' + fkey + '.font'))"
                @input="editInputSelect({ field: 'item.pages.' + page.number + '.template.layers.' + fkey + '.font', value: $event }); editInput({ field: 'item.pages.' + page.number + '.template.layers.' + fkey + '.type', value: 'text' })" />
              <div class="w-24 p-1"> &nbsp; Igazítás:</div>
              <Select classes="w-48"
                :options="[{ code: 'left', name: 'Balra' }, { code: 'center', name: 'Középre' }, { code: 'right', name: 'Jobbra' },]"
                :value="alignOption(editValue('item.pages.' + page.number + '.template.layers.' + fkey + '.align'))"
                @input="editInputSelect({ field: 'item.pages.' + page.number + '.template.layers.' + fkey + '.align', value: $event }); editInput({ field: 'item.pages.' + page.number + '.template.layers.' + fkey + '.type', value: 'text' })" />
            </div>
          </template>
          <br>
        </div>
      </div>
      <div v-if="record.item.settings.product == 'calendar'" style="user-select: text;">
        <h3>Rendelés #{{ record.code }}, saját napjaim:</h3>
        <table class="border border-black">
          <thead>
            <tr>
              <td class="p-1 font-bold border-r border-black">Dátum</td>
              <td class="p-1 font-bold">Szöveg</td>
            </tr>
          </thead>
          <tbody>
          <tr v-for="day in record.item.settings.specialDays" :key="day.month + '-' + day.day"
            class="border-t border-black">
            <td class="p-1 border-r border-black">
              {{ monthName(day.month) }} {{ day.day }}.
            </td>
            <td class="p-1">
              {{ day.text }}
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div v-if="(record.item.settings.product == 'photobook')" style="user-select: text;" class="flex flex-col my-4">
        <h3>Termék címe:</h3>
        <div class="pb-4">
          Szín: <input type="text" size="4" class="w-48" :value="editValue('item.pages.0.data.layers.text1.color')"
            @input="editInput({ field: 'item.pages.0.data.layers.text1.color', value: $event.target.value })"
            @change="editInput({ field: 'item.pages.0.data.layers.text1.color', value: $event.target.value })"> &nbsp;
          Előző választott szín: {{ record.item.pages[0].data.layers.text1.color }}
          <br>
        </div>
        <div>
          Szöveg:<br><textarea class="w-1/2" v-html="editValue('item.pages.0.data.layers.text1.text')"
            @input="editInput({ field: 'item.pages.0.data.layers.text1.text', value: $event.target.value })"
            @change="editInput({ field: 'item.pages.0.data.layers.text1.text', value: $event.target.value })"></textarea>
          <br>
        </div>
      </div>
      <div v-if="(record.item.settings.product == 'calendar' || record.item.settings.product == 'photobook')"
        style="user-select: text;" class="my-4">
        <h3>Képek:</h3>
        <table class="border-t border-b border-l border-black">
          <thead>
            <tr>
              <td class="p-1 font-bold border-r border-black">Oldal</td>
              <td class="p-1 font-bold border-r border-black">Képek</td>
            </tr>
          </thead>
          <tbody>
          <tr v-for="(page, p) in record.item.pages" :key="p" class="border-t border-black">
            <td class="p-1 border-r border-black">
              <template v-if="record.item.settings.product == 'calendar'">
                <template v-if="page.number == 0"><b>Borító</b></template>
                <template v-else><b>{{ page.data.layers.calendar.year }}. {{
                  page.data.layers.calendar.month
                }}.</b></template>
                <br># {{ page.number }}.
              </template>
              <template v-else>
                <template v-if="page.number == 0"><b>Borító</b></template>
                <template v-else><b>{{ parseInt(page.number) * 2 - 1 }}.-{{ parseInt(page.number) * 2 }}.
                    oldal</b></template>
                <br># {{ page.number }}.
              </template>
            </td>
            <td class="flex p-1 border-r border-black" :set="imi = 0">
              <template v-for="(layer, lyi) in page.template.layers">
                <div :key="lyi" v-if="layer.type == 'image' && page.data.layers[lyi]" class="p-1"
                  :set="dlayer = page.data.layers[lyi]" :_set="layim = dlayer.image" :__set="imi++">
                  <b>{{ imi }}. kép:</b><br>
                  <div v-if="layim && !layim.empty">

                    <a :href="layim.url" target="_blank">
                      <img :src="layim.tnUrl">
                    </a>
                    <div v-if="layim.w && layim.h">
                      {{ layim.w }}×{{ layim.h }} {{ layim.scale && layim.scale > 1 ? '(' + layim.scale + 'x)' : '' }}
                    </div>
                    <pre v-else>Hibás: {{ layim }}
                                        </pre>
                  </div>
                  <div v-else> Nincs kép </div>
                </div>
              </template>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div v-if="record.item.settings.product == 'other'" style="user-select: text;">
        <h3>Egyedi rendelés:</h3>
        Index kép feltöltése: <input type="file" class="w-96" @change="imageUpload('image_index', 1000, $event)">
        <div v-if="bimPlace[1000]">
          új index kép:<br>
          <img :src="bimPlace[1000]" class="h-auto w-96">
          <h1 class="text-red-600">Ne felejtsd el menteni a megrendelést!</h1>
        </div>
        <div v-if="record.image_index && !bimPlace[1000]">
          index kép:<br>
          <img :src="record.image_index.pvUrl" class="h-auto w-96">
        </div>
        <br class="pb-16">
        Nyomtatható fájl feltöltése: <input type="file" class="w-96" @change="fileUpload('printable', 1100, $event)">
        <div v-if="bimPlace[1100]">
          <a :href="bimPlace[1100]" target="_blank" class="font-bold text-blue-800">
            <span><i class="text-2xl text-red-800 las la-file-alt"></i>Nyomtatható fájl</span>
          </a>
          <h1 class="text-red-600">Ne felejtsd el menteni a megrendelést!</h1>
        </div>
        <div v-if="record.printable && !bimPlace[1100]">
          <a :href="record.printable.url + '?g=' + record.generation" target="_blank" class="font-bold text-blue-800">
            <span><i class="text-2xl text-red-800 las la-file-alt"></i>Nyomtatható fájl</span>
          </a>
        </div>
        <br class="pb-16">
      </div>
      <div v-if="record.item.settings.product == 'photo'"
        style="user-select: text;" class="my-4">
        <h3>Képek:</h3>
        <table class="border-t border-b border-l border-black">
          <thead>
            <tr>
                <th class="p-1 font-bold border-r border-black">#</th>
                <th class="p-1 font-bold border-r border-black">Kép</th>
                <th class="p-1 font-bold border-r border-black">Termék</th>
                <th class="p-1 font-bold border-r border-black">Méret</th>
                <th class="p-1 font-bold border-r border-black">db</th>
                <th class="p-1 font-bold border-r border-black">Felbontás</th>
                <th class="p-1 font-bold border-r border-black">beállítások</th>
            </tr>
          </thead>
          <tbody>
          <tr v-for="(photo, p) in record.item.photos" :key="p" class="border-t border-black">
            <td class="p-1 border-r border-black">
              {{ p + 1 }}.
            </td>
            <td class="p-1 border-r border-black">
              <div class="flex flex-col items-center">
                <img :src="photo.src" class="max-h-48 max-w-full h-auto object-contain" loading="lazy">
                <div class="text-xs mt-1">{{ photo.filename }}</div>
              </div>
            </td>
            <td class="p-1 border-r border-black">
              {{ photoProduct(photo) }}
            </td>
            <td class="p-1 border-r border-black">
              {{ formatPhotoSize(photo.size) }}
            </td>
            <td class="p-1 border-r border-black">
              {{ photo.pcs }} db
            </td>
            <td class="p-1 border-r border-black">
              <span v-html="getPhotoQualityStatus(photo)"></span><br>
              <strong>DPI: {{ calculatePhotoDPI(photo) }}</strong><br>
              eredeti méret: {{ photo.data.w }}×{{ photo.data.h }} px<br>
              kivágott méret: {{ Math.round((photo.cx2 - photo.cx1) * photo.data.w / photo.w) }}×{{ Math.round((photo.cy2 - photo.cy1) * photo.data.h / photo.h) }} px<br>
            </td>
            <td class="p-1 border-r border-black" v-html="photoOptions(photo)"></td>
          </tr>
          </tbody>
        </table>
       </div>
    </template>
    <template v-if="table == 'users' && !loading && record">
      <h2>Fiók belépési link:</h2>
      <a class="text-blue-700"
        :href="'https://internetprint.eu/' + record.language + '/account/#login-' + record.token">https://internetprint.eu/{{
          record.language
        }}/account/#login-{{ record.token }}</a>
    </template>
    <Modal ref="modal_history" title="Napló" grey class="text-gray-800">
      <div v-if="!loading && record && record._history" class="text-gray-800">
        <div v-for="r in record._history" :key="r.at" class="p-2 border-t border-black ">
          {{ $time(new Date(r.at * 1000)) }} : <b>{{ r.user.name }}</b> {{ r.set }}
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { ShippingQuote } from '../../../../mono/print/PrintQuote.js'
import { PhotoSizes } from '../../../../mono/print/photo.js'

const rates = { "AED": 3.672951, "AFN": 95.889778, "ALL": 107.366291, "AMD": 483.27152, "ANG": 1.801312, "AOA": 585, "ARS": 100.7747, "AUD": 1.39865, "AWG": 1.80025, "AZN": 1.700805, "BAM": 1.733293, "BBD": 2, "BDT": 85.74934, "BGN": 1.735484, "BHD": 0.376966, "BIF": 1994.344572, "BMD": 1, "BND": 1.370223, "BOB": 6.905713, "BRL": 5.610701, "BSD": 1, "BTC": 0.000017462251, "BTN": 74.895631, "BWP": 11.820933, "BYN": 2.559133, "BZD": 2.01464, "CAD": 1.274291, "CDF": 1999.765501, "CHF": 0.926023, "CLF": 0.030098, "CLP": 832.05, "CNH": 6.385432, "CNY": 6.3822, "COP": 3978.534815, "CRC": 639.318383, "CUC": 1, "CUP": 25.75, "CVE": 97.95, "CZK": 22.764513, "DJF": 177.92768, "DKK": 6.58985, "DOP": 56.5296, "DZD": 138.82, "EGP": 15.7048, "ERN": 15.000155, "ETB": 48.170029, "EUR": 0.886211, "FJD": 2.1264, "FKP": 0.748881, "GBP": 0.748881, "GEL": 3.095, "GGP": 0.748881, "GHS": 6.142755, "GIP": 0.748881, "GMD": 52.425, "GNF": 9472.013443, "GTQ": 7.738789, "GYD": 209.235741, "HKD": 7.79975, "HNL": 24.096845, "HRK": 6.6726, "HTG": 98.81349, "HUF": 326.813977, "IDR": 14344.5, "ILS": 3.155005, "IMP": 0.748881, "INR": 75.07849, "IQD": 1457.225137, "IRR": 42275, "ISK": 130.28, "JEP": 0.748881, "JMD": 155.642774, "JOD": 0.709, "JPY": 113.444, "KES": 112.5, "KGS": 84.774699, "KHR": 4065.736547, "KMF": 436.000041, "KPW": 900, "KRW": 1191.164345, "KWD": 0.30245, "KYD": 0.832868, "KZT": 436.019072, "LAK": 10829.310658, "LBP": 1511.358493, "LKR": 202.392326, "LRD": 142.25, "LSL": 16.202643, "LYD": 4.612992, "MAD": 9.244198, "MDL": 17.749473, "MGA": 3987.826637, "MKD": 54.611611, "MMK": 1789.811559, "MNT": 2854.559306, "MOP": 8.027987, "MRO": 356.999828, "MRU": 36.240856, "MUR": 43.500992, "MVR": 15.45, "MWK": 815.95891, "MXN": 21.84407, "MYR": 4.2385, "MZN": 63.83, "NAD": 16.26, "NGN": 411.285101, "NIO": 35.230131, "NOK": 9.076374, "NPR": 119.758938, "NZD": 1.464611, "OMR": 0.384978, "PAB": 1, "PEN": 4.033977, "PGK": 3.51889, "PHP": 50.313503, "PKR": 176.553702, "PLN": 4.164222, "PYG": 6822.056023, "QAR": 3.646364, "RON": 4.3863, "RSD": 104.225, "RUB": 74.941, "RWF": 1035.004239, "SAR": 3.751529, "SBD": 8.064563, "SCR": 13.667943, "SDG": 438, "SEK": 9.1329, "SGD": 1.368577, "SHP": 0.748881, "SLL": 11119.299798, "SOS": 578.158713, "SRD": 21.52, "SSP": 130.26, "STD": 21187.940504, "STN": 22.195, "SVC": 8.745203, "SYP": 2512.5, "SZL": 16.202498, "THB": 33.67, "TJS": 11.286041, "TMT": 3.51, "TND": 2.882, "TOP": 2.28298, "TRY": 12.747741, "TTD": 6.776824, "TWD": 27.782501, "TZS": 2302, "UAH": 27.077955, "UGX": 3563.214629, "USD": 1, "UYU": 44.184976, "UZS": 10771.310877, "VES": 4.57705, "VND": 22696.324365, "VUV": 111.998805, "WST": 2.563531, "XAF": 581.316032, "XAG": 0.04287981, "XAU": 0.00055673, "XCD": 2.70255, "XDR": 0.714404, "XOF": 581.316032, "XPD": 0.00055911, "XPF": 105.753052, "XPT": 0.00104494, "YER": 250.249937, "ZAR": 16.130107, "ZMW": 17.765578, "ZWL": 322 }

const fontList = {
  'AmaticSC-Bold.ttf': 'AmaticSC-Bold.ttf',
  'AmaticSC-Regular.ttf': 'AmaticSC-Regular.ttf',
  'CormorantSC-Bold.ttf': 'CormorantSC-Bold.ttf',
  'CormorantSC-Regular.ttf': 'CormorantSC-Regular.ttf',
  'DancingScript-Bold.ttf': 'DancingScript-Bold.ttf',
  'DancingScript-Regular.ttf': 'DancingScript-Regular.ttf',
  'EBGaramond-Bold.ttf': 'EBGaramond-Bold.ttf',
  'EBGaramond-BoldItalic.ttf': 'EBGaramond-BoldItalic.ttf',
  'EBGaramond-Italic.ttf': 'EBGaramond-Italic.ttf',
  'EBGaramond-Regular.ttf': 'EBGaramond-Regular.ttf',
  'GreatVibes-Regular.ttf': 'GreatVibes-Regular.ttf',
  'Itim-Regular.ttf': 'Itim-Regular.ttf',
  'Lemonada-Bold.ttf': 'Lemonada-Bold.ttf',
  'Lemonada-Regular.ttf': 'Lemonada-Regular.ttf',
  'LibreBaskerville-Bold.ttf': 'LibreBaskerville-Bold.ttf',
  'LibreBaskerville-Italic.ttf': 'LibreBaskerville-Italic.ttf',
  'LibreBaskerville-Regular.ttf': 'LibreBaskerville-Regular.ttf',
  'Lora-Bold.ttf': 'Lora-Bold.ttf',
  'Lora-BoldItalic.ttf': 'Lora-BoldItalic.ttf',
  'Lora-Italic.ttf': 'Lora-Italic.ttf',
  'Lora-Regular.ttf': 'Lora-Regular.ttf',
  'Merienda-Bold.ttf': 'Merienda-Bold.ttf',
  'Merienda-Regular.ttf': 'Merienda-Regular.ttf',
  'Merriweather-Bold.ttf': 'Merriweather-Bold.ttf',
  'Merriweather-BoldItalic.ttf': 'Merriweather-BoldItalic.ttf',
  'Merriweather-Italic.ttf': 'Merriweather-Italic.ttf',
  'Merriweather-Regular.ttf': 'Merriweather-Regular.ttf',
  'Nunito-Bold.ttf': 'Nunito-Bold.ttf',
  'Nunito-BoldItalic.ttf': 'Nunito-BoldItalic.ttf',
  'Nunito-Italic.ttf': 'Nunito-Italic.ttf',
  'Nunito-Regular.ttf': 'Nunito-Regular.ttf',
  'OpenSans-Bold.ttf': 'OpenSans-Bold.ttf',
  'OpenSans-BoldItalic.ttf': 'OpenSans-BoldItalic.ttf',
  'OpenSans-Italic.ttf': 'OpenSans-Italic.ttf',
  'OpenSans-Regular.ttf': 'OpenSans-Regular.ttf',
  'Parisienne-Regular.ttf': 'Parisienne-Regular.ttf',
  'PassionsConflict-Regular.ttf': 'PassionsConflict-Regular.ttf',
  'PlayfairDisplay-Bold.ttf': 'PlayfairDisplay-Bold.ttf',
  'PlayfairDisplay-BoldItalic.ttf': 'PlayfairDisplay-BoldItalic.ttf',
  'PlayfairDisplay-Italic.ttf': 'PlayfairDisplay-Italic.ttf',
  'PlayfairDisplay-Regular.ttf': 'PlayfairDisplay-Regular.ttf',
  'RedHatDisplay-Bold.ttf': 'RedHatDisplay-Bold.ttf',
  'RedHatDisplay-BoldItalic.ttf': 'RedHatDisplay-BoldItalic.ttf',
  'RedHatDisplay-Italic.ttf': 'RedHatDisplay-Italic.ttf',
  'RedHatDisplay-Regular.ttf': 'RedHatDisplay-Regular.ttf',
  'Righteous-Regular.ttf': 'Righteous-Regular.ttf',
  'Sacramento-Regular.ttf': 'Sacramento-Regular.ttf',
  'Taviraj-Bold.ttf': 'Taviraj-Bold.ttf',
  'Taviraj-BoldItalic.ttf': 'Taviraj-BoldItalic.ttf',
  'Taviraj-Italic.ttf': 'Taviraj-Italic.ttf',
  'Taviraj-Regular.ttf': 'Taviraj-Regular.ttf',
  'Vollkorn-Bold.ttf': 'Vollkorn-Bold.ttf',
  'Vollkorn-BoldItalic.ttf': 'Vollkorn-BoldItalic.ttf',
  'Vollkorn-Italic.ttf': 'Vollkorn-Italic.ttf',
  'Vollkorn-Regular.ttf': 'Vollkorn-Regular.ttf',
  'Voltaire-Regular.ttf': 'Voltaire-Regular.ttf [Hiányzó karakterek]',
  'amaticsc.ttf': 'amaticsc.ttf  [Hiányzó karakterek]',
  'amazone.ttf': 'amazone.ttf  [Hiányzó karakterek]',
  'antiquab.ttf': 'antiquab.ttf ',
  'arial.ttf': 'arial.ttf',
  'arialb.ttf': 'arialb.ttf',
  'arialbi.ttf': 'arialbi.ttf',
  'ariali.ttf': 'ariali.ttf',
  'arialn.ttf': 'arialn.ttf',
  'arialnb.ttf': 'arialnb.ttf',
  'arialnbi.ttf': 'arialnbi.ttf',
  'arialni.ttf': 'arialni.ttf',
  'avenir.ttf': 'avenir.ttf',
  'bauhaus.ttf': 'bauhaus.ttf  [Hiányzó karakterek]',
  'bauhausd.ttf': 'bauhausd.ttf  [Hiányzó karakterek]',
  'calibri.ttf': 'calibri.ttf',
  'calibrib.ttf': 'calibrib.ttf',
  'candara.ttf': 'candara.ttf',
  'candarab.ttf': 'candarab.ttf',
  'candarabi.ttf': 'candarabi.ttf',
  'candarai.ttf': 'candarai.ttf',
  'comfortaa.ttf': 'comfortaa.ttf',
  'constan.ttf': 'constan.ttf',
  'constanb.ttf': 'constanb.ttf',
  'constanbi.ttf': 'constanbi.ttf',
  'constani.ttf': 'constani.ttf',
  'erasb.ttf': 'erasb.ttf  [Hiányzó karakterek]',
  'erasd.ttf': 'erasd.ttf  [Hiányzó karakterek]',
  'erasitct.ttf': 'erasitct.ttf  [Hiányzó karakterek]',
  'erasitctb.ttf': 'erasitctb.ttf  [Hiányzó karakterek]',
  'erasitctd.ttf': 'erasitctd.ttf  [Hiányzó karakterek]',
  'erasitctm.ttf': 'erasitctm.ttf  [Hiányzó karakterek]',
  'erasl.ttf': 'erasl.ttf  [Hiányzó karakterek]',
  'erasm.ttf': 'erasm.ttf  [Hiányzó karakterek]',
  'frab.ttf': 'frab.ttf',
  'frabb.ttf': 'frabb.ttf',
  'frabbi.ttf': 'frabbi.ttf',
  'frabi.ttf': 'frabi.ttf',
  'frad.ttf': 'frad.ttf',
  'fradi.ttf': 'fradi.ttf',
  'framd.ttf': 'framd.ttf',
  'framdc.ttf': 'framdc.ttf',
  'framdcn.ttf': 'framdcn.ttf',
  'framdi.ttf': 'framdi.ttf',
  'gara.ttf': 'gara.ttf',
  'garab.ttf': 'garab.ttf',
  'garabd.ttf': 'garabd.ttf',
  'garabi.ttf': 'garabi.ttf',
  'garai.ttf': 'garai.ttf',
  'georgia.ttf': 'georgia.ttf',
  'georgiab.ttf': 'georgiab.ttf',
  'georgiabd.ttf': 'georgiabd.ttf',
  'georgiabi.ttf': 'georgiabi.ttf',
  'georgiai.ttf': 'georgiai.ttf',
  'gothic.ttf': 'gothic.ttf',
  'gothicb.ttf': 'gothicb.ttf',
  'gothicbi.ttf': 'gothicbi.ttf',
  'gothici.ttf': 'gothici.ttf',
  'hotrod.ttf': 'hotrod.ttf  [Hiányzó karakterek]',
  'huottawab.ttf': 'huottawab.ttf  [Hiányzó karakterek]',
  'huottawabi.ttf': 'huottawabi.ttf  [Hiányzó karakterek]',
  'husabotb.ttf': 'husabotb.ttf  [Hiányzó karakterek]',
  'husabotbi.ttf': 'husabotbi.ttf  [Hiányzó karakterek]',
  'husaboti.ttf': 'husaboti.ttf  [Hiányzó karakterek]',
  'husafrolei.ttf': 'husafrolei.ttf  [Hiányzó karakterek]',
  'husouthernb.ttf': 'husouthernb.ttf  [Hiányzó karakterek]',
  'husouthernbi.ttf': 'husouthernbi.ttf  [Hiányzó karakterek]',
  'husoutherni.ttf': 'husoutherni.ttf  [Hiányzó karakterek]',
  'janda.ttf': 'janda.ttf  [Hiányzó karakterek]',
  'lbritedi.ttf': 'lbritedi.ttf  [Hiányzó karakterek]',
  'museo100.ttf': 'museo100.ttf',
  'museo300.ttf': 'museo300.ttf',
  'museo500.ttf': 'museo500.ttf',
  'museo700.ttf': 'museo700.ttf',
  'museo900.ttf': 'museo900.ttf',
  'myriadhu.ttf': 'myriadhu.ttf',
  'myriadhub.ttf': 'myriadhub.ttf',
  'myriadpro.ttf': 'myriadpro.ttf',
  'myriadprob.ttf': 'myriadprob.ttf',
  'opensans.ttf': 'opensans.ttf',
  'opensansb.ttf': 'opensansb.ttf',
  'opensansi.ttf': 'opensansi.ttf',
  'opensanssb.ttf': 'opensanssb.ttf',
  'pala.ttf': 'pala.ttf',
  'palab.ttf': 'palab.ttf',
  'palabi.ttf': 'palabi.ttf',
  'palai.ttf': 'palai.ttf',
  'parisienne.ttf': 'parisienne.ttf  [Hiányzó karakterek]',
  'patrickhand.ttf': 'patrickhand.ttf  [Hiányzó karakterek]',
  'sacramento.ttf': 'sacramento.ttf  [Hiányzó karakterek]',
  'shannon.ttf': 'shannon.ttf  [Hiányzó karakterek]',
  'shannonb.ttf': 'shannonb.ttf  [Hiányzó karakterek]',
  'tahoma.ttf': 'tahoma.ttf',
  'tahomab.ttf': 'tahomab.ttf',
  'tahomai.ttf': 'tahomai.ttf',
  'times.ttf': 'times.ttf',
  'timesb.ttf': 'timesb.ttf',
  'timesbi.ttf': 'timesbi.ttf',
  'timesi.ttf': 'timesi.ttf',
  'trajanpro.ttf': 'trajanpro.ttf  [Hiányzó karakterek]',
  'trajanprob.ttf': 'trajanprob.ttf  [Hiányzó karakterek]',
  'trebuc.ttf': 'trebuc.ttf ',
  'trebucb.ttf': 'trebucb.ttf',
  'trebucbi.ttf': 'trebucbi.ttf ',
  'zapfhdn.ttf': 'zapfhdn.ttf  [Hiányzó karakterek]',
}

const requoteFields = {
  'courier': true,
  'payment_type': true,
  'discountcode': true,
  'item.settings.pcs': true,
  'item.settings.shipping_free': true,
  'item.settings.shipping_free_extra': true,
  'item.quote.product_price': true,
  'item.quote.product_price_before': true,
  'item.quote.shipping_price': true,
}

import Select from '@/components/Select.vue'
import Form from '@/components/Form.vue'
import Modal from '@/components/Modal.vue'
import set from 'lodash.set'


var loget = require('lodash.get')
var loset = require('lodash.set')

function objget(obj, path, def) {
  path = path.replace(/\.([0-9+])\./g, '.[$1].')
  //console.log('new path:', path)
  return loget(obj, path, def)
}

function objset(obj, path, val) {
  path = path.replace(/\.([0-9+])\./g, '.[$1].')
  //console.log('new path:', path)
  loset(obj, path, val)
}

export default {
  name: 'Edit',
  components: {
    Select,
    Form,
    Modal,
  },
  data() {
    return {
      update: 0,
      loading: false,
      error: false,
      record_raw: false,
      modify: {},
      bimPlace: {},
    }
  },
  computed: {
    record() {
      let r = JSON.parse(JSON.stringify(this.record_raw))
      for (let m in this.modify) {
        objset(r, m, this.modify[m])
      }
      return r
    },
    table() {
      return this.$route.params.table
    },
    title() {
      return this.$schema[this.table].title_single + ': ' + this.record[this.$schema[this.table].list_field]
    },
    textFields() {
      return {
        company: 'Cég',
        slogan: 'Szlogen',
        slogan2: 'Szlogen 2',
        monogram: 'Monogram',
        name: 'Név',
        jobtitle: 'Titulus',
        jobtitle2: 'Titulus 2',
        address1: 'Címsor 1',
        address2: 'Címsor 2',
        phone: 'Telefon',
        fax: 'Fax',
        mobile: 'Mobil',
        email: 'Email',
        web: 'Web',
        data1: 'Adat 1',
        data2: 'Adat 2',
        data3: 'Adat 3',
      }
    },
    fontOptions() {
      let options = [{ name: '--', value: '' }]
      for (let f in fontList) {
        options.push({ name: fontList[f], code: f })
      }
      return options
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.refresh()
        if (this.table == 'orders') {
            window.setInterval(async () => {
                if (this.needsRequote) {
                    await this.checkRequote()
                    this.needsRequote = false
                }
            }, 600)
        }
    })
  },
  watch: {
    $route() {
      this.$nextTick(() => {
        this.refresh()
      })
    },
  },
  methods: {
    formatPhotoSize(size) {
      try {
        // Extract dimensions from size string (e.g., "c70x50" -> "70 x 50 cm")
        const sizeMatch = size.match(/(\d+)x(\d+)/);
        if (!sizeMatch) return size; // Return original if no match

        const width = parseInt(sizeMatch[1]);
        const height = parseInt(sizeMatch[2]);

        return `${width} x ${height} cm`;
      } catch (error) {
        return size; // Return original on error
      }
    },
    calculatePhotoDPI(photo) {
      try {
        // Extract physical dimensions from size string (e.g., "c70x50" -> 70cm x 50cm)
        const sizeMatch = photo.size.match(/(\d+)x(\d+)/);
        if (!sizeMatch) return 'N/A';

        const physicalWidthCm = parseInt(sizeMatch[1]);
        const physicalHeightCm = parseInt(sizeMatch[2]);

        // Convert to inches (1 inch = 2.54 cm)
        const physicalWidthInches = physicalWidthCm / 2.54;
        const physicalHeightInches = physicalHeightCm / 2.54;

        // Calculate cut image pixel dimensions
        const cutWidthPx = Math.round((photo.cx2 - photo.cx1) * photo.data.w / photo.w);
        const cutHeightPx = Math.round((photo.cy2 - photo.cy1) * photo.data.h / photo.h);

        // Calculate diagonal in pixels and inches
        const pixelDiagonal = Math.sqrt(cutWidthPx * cutWidthPx + cutHeightPx * cutHeightPx);
        const physicalDiagonal = Math.sqrt(physicalWidthInches * physicalWidthInches + physicalHeightInches * physicalHeightInches);

        // DPI = pixels per inch
        const dpi = Math.round(pixelDiagonal / physicalDiagonal);

        return `${dpi} DPI`;
      } catch (error) {
        return 'Error';
      }
    },
    getPhotoDPIValue(photo) {
      try {
        // Extract physical dimensions from size string (e.g., "c70x50" -> 70cm x 50cm)
        const sizeMatch = photo.size.match(/(\d+)x(\d+)/);
        if (!sizeMatch) return null;

        const physicalWidthCm = parseInt(sizeMatch[1]);
        const physicalHeightCm = parseInt(sizeMatch[2]);

        // Convert to inches (1 inch = 2.54 cm)
        const physicalWidthInches = physicalWidthCm / 2.54;
        const physicalHeightInches = physicalHeightCm / 2.54;

        // Calculate cut image pixel dimensions
        const cutWidthPx = Math.round((photo.cx2 - photo.cx1) * photo.data.w / photo.w);
        const cutHeightPx = Math.round((photo.cy2 - photo.cy1) * photo.data.h / photo.h);

        // Calculate diagonal in pixels and inches
        const pixelDiagonal = Math.sqrt(cutWidthPx * cutWidthPx + cutHeightPx * cutHeightPx);
        const physicalDiagonal = Math.sqrt(physicalWidthInches * physicalWidthInches + physicalHeightInches * physicalHeightInches);

        // DPI = pixels per inch
        return Math.round(pixelDiagonal / physicalDiagonal);
      } catch (error) {
        return null;
      }
    },
    getPhotoQualityStatus(photo) {
      try {
        const actualDPI = this.getPhotoDPIValue(photo);
        if (actualDPI === null) return '???';

        // Get minimum DPI from PhotoSizes for this size
        const minDPI = PhotoSizes[photo.size][5];
        if (!minDPI) return '??';

        const lowThreshold = minDPI * 0.5; // 50% of minimum DPI

        if (actualDPI >= minDPI) {
          return '<span style="color: green; font-weight: bold;"><i class="las la-check-circle"></i> Felbontás: OK</span>';
        } else if (actualDPI >= lowThreshold) {
          return '<span style="color: orange; font-weight: bold;"><i class="las la-exclamation-triangle"></i> Felbontás: Alacsony (min: '+minDPI+' DPI)</span>';
        } else {
          return '<span style="color: red; font-weight: bold;"><i class="las la-times-circle"></i> Felbontás: Rossz (min: '+minDPI+' DPI)</span>';
        }
      } catch (error) {
        return '???';
      }
    },
    monthName(n) {
      let mo = [
        'január',
        'február',
        'március',
        'április',
        'május',
        'június',
        'július',
        'augusztus',
        'szeptember',
        'október',
        'november',
        'december'
      ]
      return mo[n - 1]
    },
    fontOption(font) {
      return { name: fontList[font], code: font }
    },
    alignOption(opt) {
      const aligns = {
        'left': 'Balra',
        'center': 'Középre',
        'right': 'Jobbra'
      }
      return { name: aligns[opt], code: opt }
    },
    photoProduct(photo) {
      const PhotoModes = {
        'photo': 'Fotókidolgozás',
        'print': 'Fotónyomtatás',
        'poster': 'Poszter nyomtatás',
        'foamboard': 'Habkarton nyomtatás',
        'pvc': 'PVC lemez nyomtatás',
        'canvas': 'Vászonkép',
      }
      return PhotoModes[photo.mode]
    },
    photoOptions(photo) {
      const ccd = {
        'or': '- nincs képjavítás- ',
        'wb': '<b>Auto fehéregyensúly</b>',
        'en': '<b>AI képjavítás</b>',
      }
      return ccd[photo.cc]
    },
    async refresh() {
      this.loading = true
      this.modify = {}
      this.isNumber = {}
      let data = {
        table: this.table,
        filter: {
          _id: '_'+this.$route.params.id,
        },
      }
      //console.log(data)
      const res = await this.$store.API('admin/list', data)
      if (res && res.list.length > 0) {
        this.record_raw = res.list[0]
        if (this.table == 'orders')  {
          this.initProductPrice()
        }
      } else {
        this.record_raw = false
      }
      document.title = this.title
      this.update++
      this.loading = false
    },
    editForm() {
      let l = this.loading
      let e = this.update
      let fieldsets = [
        { name: "group1", fields: [], classes: "p-4 border border-gray-400 rounded-lg flex flex-col content-end text-right" },
        { name: "group2", fields: [], classes: "p-4 border border-gray-400 rounded-lg flex flex-col content-end text-right" },
        { name: "group3", fields: [], classes: "p-4 border border-gray-400 rounded-lg flex flex-col content-end text-right" },
        { name: "group4", fields: [], classes: "p-4 border border-gray-400 rounded-lg flex flex-col content-end text-right" },
        { name: "group5", fields: [], classes: "p-4 border border-gray-400 rounded-lg flex flex-col content-end text-right" },
        { name: "group6", fields: [], classes: "p-4 border border-gray-400 rounded-lg flex flex-col content-end text-right" },
      ]


      const VPROP = {
        'if':true,
        'edit':true,
        'readonly':true,
      }
      let fields = this.$schema[this.table].fields
      for (let fid in fields) {
        let fieldo = JSON.parse(JSON.stringify(fields[fid]))
        if (typeof(fieldo.if) == 'undefined') {
          fieldo.if = true
        }
        for (let propid in fieldo) {
          let prop = fieldo[propid]
          if (VPROP[propid] && typeof prop == 'object') {
            let psel = true
            //console.log('fid:', fid, 'propid:', propid, 'prop:', prop)
            for (let ifkey1 in prop) {
              let ifkey = ifkey1.replace(/^[-]+/gm, '')
              let checkval = ''+prop[ifkey1]
              let val = ''+this.editValue(ifkey1)
              //console.log(' - fid:', fid,'ifkey:', ifkey, 'val:', val, 'checkval:', checkval)
              if (checkval.indexOf('!') == 0) {
                checkval = checkval.replace('!', '')
                if (checkval == val) {
                  psel = false
                }
              } else if (checkval.indexOf('$exists') == 0) {
                if (!val) {
                  psel = false
                }
              } else {
                if (checkval != val) {
                  psel = false
                }
              }
            }
            fieldo[propid] = psel
            //console.log(' - RESULT :: fid:', fid, 'propid:', propid, psel)
          }
        }
        if (fieldo.if && fieldo.edit) {
          let fido = fid
          fid = fid.replace(/^[-]+/gm, '')
          let field = this.$schema[this.table].fields[fid]
          //console.log("FID:", fid, "field:", field)
          field.name = fid
          if (!field.type) {
            field.type = "text"
          }
          if (!fieldo.edit_group) {
            fieldo.edit_group = 1
          }
          let group = fieldo.edit_group - 1
          if (fieldo.edit_group_title) {
            fieldsets[group].title = fieldo.edit_group_title
          }
          if (field.type == "text") {
            fieldsets[group].fields.push({ name: field.name, type: "text", readonly: field.readonly, title: field.title + ':', placeholder: field.placeholder, classes: 'p-0 pb-2 justify-end', inputClasses: field.classes ? field.classes : 'w-4/5', labelAlways: true, labelClasses: 'justify-end w-full flex px-4' })
          } else if (field.type == "number") {
            fieldsets[group].fields.push({ name: field.name, type: "number", readonly: field.readonly, title: field.title + ':', placeholder: field.placeholder, classes: 'p-0 pb-2 justify-end', inputClasses: field.classes ? field.classes : 'w-4/5', labelAlways: true, labelClasses: 'justify-end w-full flex px-4' })
          } else if (field.type == "textarea") {
            fieldsets[group].fields.push({ name: field.name, type: "textarea", title: field.title + ':', placeholder: field.placeholder, classes: 'p-0 pb-2', inputClasses: field.classes ? field.classes : 'w-full', labelAlways: true, labelClasses: 'w-full flex flex-col px-4', lines: 7 })
          } else if (field.type == "select") {
            let maxw = 10
            let options = [{ code: '-', name: '- MIND -' }]
            for (let code in field.values) {
              let opt = field.values[code]
              options.push({ code: code, name: opt.title })
              if (opt.title.length > maxw) {
                maxw = opt.title.length
              }
            }
            fieldsets[group].fields.push({ name: field.name, options: options, type: "select", title: field.title + ':', minWidth: maxw, classes: 'p-0 pb-1 justify-end', inputClasses: 'p-0 ' + field.classes, labelClasses: 'flex p-0' })
          } else if (field.type == "time") {
            fieldsets[group].fields.push({ name: field.name, type: "date", range: true, title: field.title + ':', labelAlways: true, labelClasses: 'flex p-0 pb-2', classes: 'p-0 justify-end', inputClasses: field.classes })
          } else if (field.type == "checkbox") {
            fieldsets[group].fields.push({ name: field.name, type: "checkbox", title: field.title, placeholder: field.placeholder, classes: 'p-0 pb-2 justify-end', inputClasses: field.classes ? field.classes : 'w-4/5', labelAlways: true, labelClasses: 'justify-end w-full flex px-4' })
          }
        }
      }

      let f = {
        fieldsets: fieldsets
      }
      return f
    },
    async editInput(e) {
      let fid = '' + e.field
      fid = fid.replace(/^[-]+/gm, '')
      this.modify[fid] = e.value
      this.needsRequote = true
      this.update++
    },
    async editInputNumber(e) {
      e.val = this.toFloat(e.val)
      this.isNumber[e.key] = true
      await this.editInput(e)
    },
    async editInputSelect(e) {
      let fid = e.field
      fid = fid.replace(/^[-]+/gm, '')
      this.modify[fid] = e.value.code
      this.needsRequote = true
      this.update++
    },
    toFloat(s) {
      s = ('' + s)
        .replaceAll(/([^0-9.,]+)/g, '')
        .replaceAll(',', '.')
        .replaceAll(/([.]+)/g, '.')
        .replace('.', '¤')
        .replaceAll('.', '')
        .replace('¤', '.')

      let val = parseFloat(s)
      if (Number.isNaN(val)) {
        s = ''
      }
      return val
    },
    editValue(fid) {
      let u = this.update
      let fido = fid
      fid = fid.replace(/^[-]+/gm, '')
      let field = this.$schema[this.table].fields[fido]
      let value = ''

      let mfv = this.modify[fid]
      if (typeof (mfv) != 'undefined') {
        value = mfv
      } else {
        value = objget(this.record, fid)
      }
      if (typeof (value) == 'undefined') {
        if (field) {
          if (field.type == "select") {
            value = '-'
          } else if (field.type == "date") {
            value = null
          }
        } else {
          value = null
        }
      }

      return value
    },
    async checkRequote() {
      let needrq = false
      for (let key in requoteFields) {
        if (typeof (this.modify[key]) != 'undefined') {
          needrq = true
        }
      }
      if (needrq) {
        await this.requote()
      }
    },
    initProductPrice() {
      if (!this.record.item.quote.product_price_before) {
        this.modify['item.quote.product_price_before'] = parseFloat(this.record_raw.item.quote.product_price)
      }
    },
    async requote() {
      this.initProductPrice()
      let product_price = parseFloat(this.record.item.quote.product_price_before)
      console.log("REQUOTE", product_price)


      let dc = this.modify['discountcode']
      if (dc) {
        dc = dc.replace(/\s+/g, '').toUpperCase()
      }
      if (this.record.item.settings.discountcode && !dc) {
        //console.log("requote old discount code 1 ", this.record.item.settings, this.record.item.quote)
        dc = this.record.item.settings.discountcode.code
        dc = dc.replace(/\s+/g, '').toUpperCase()
        //console.log("requote old discount code", dc)
        this.modify['discountcode'] = dc
      }
      if (dc && dc.length > 3) {
        if (dc != this.modify['checked_discountcode']) {

          // recalculate product or shipping here
          console.log('checking discount code', dc)
          let res = await this.$store.API('account/discountcode', { code: dc, dontcheckalive: true })
          let pct = 0
          if (res && res.found) {
            pct = res.percent
            this.modify['item.settings.discountcode'] = res
            this.modify['checked_discountcode'] = res.name
            this.modify['item.quote.discountcode'] = res.name
            this.modify['item.quote.discount_percent'] = parseFloat(pct)
            if (pct > 0) {
              product_price = product_price * (1.0 - (pct / 100.0))
            }
            if (pct > 99) {
              product_price = 0
              this.modify['item.settings.shipping_free'] = true
              this.modify['item.settings.shipping_free_extra'] = true
            }
          } else {
            this.modify['item.settings.discountcode'] = false
            this.modify['item.quote.discountcode'] = 'ÉRVÉNYTELEN: "' + dc + '"'
            this.modify['checked_discountcode'] = dc
            this.modify['item.quote.discount_percent'] = 0.0
          }
        }
      } else {
        this.modify['checked_discountcode'] = ''
        this.modify['item.settings.discountcode'] = false
        this.modify['item.quote.discountcode'] = ''
        this.modify['item.quote.discount_percent'] = 0.0
      }

      let rates = this.$store.state._rates.rates
      let sc = ShippingQuote(this.record, this.record.item, rates)
      //console.log("SHIPPING QUOTE:", sc.quote, rates)
      let shipping_price = sc.quote.shipping_price

      this.modify['item.quote.product_price'] = parseFloat(product_price)
      this.modify['item.quote.shipping_price'] = parseFloat(shipping_price)
      this.modify['item.quote.price'] = parseFloat(product_price) + parseFloat(shipping_price)
      //console.log(this.modify)
      this.update++
    },
    futch(url, opts = {}, onProgress) {
      return new Promise((res, rej) => {
        var xhr = new XMLHttpRequest()
        xhr.open(opts.method || 'get', url)
        for (var k in opts.headers || {}) xhr.setRequestHeader(k, opts.headers[k])
        xhr.responseType = 'json'
        xhr.onload = (e) => res(e.target.response)
        xhr.onerror = rej
        if (xhr.upload && onProgress) xhr.upload.onprogress = onProgress // event.loaded / event.total * 100 ; //event.lengthComputable
        xhr.send(opts.body)
      })
    },
    async imageUpload(fid, page, e) {
      let fileList = e.target.files
      let fileCount = fileList.length
      if (!fileCount) {
        return
      }
      const formData = new FormData()
      Array.from(Array(fileList.length).keys()).map((i) => {
        formData.append('image', fileList[i], fileList[i].name)
      })
      let sid = this.editValue('sid')
      if (sid) {
        formData.append('sid', this.record.sid)
      }
      let api = this.$config.api.cloud
      this.futch(
        api + 'image/upload',
        {
          method: 'POST',
          body: formData,
        },

        (prg) => {
        }

      )
        .then((data) => {
          let sid = this.editValue('sid')
          if (!sid) {
            this.editInput({ field: 'sid', value: data.sid })
            sid = data.sid
          }

          this.editInput({ field: fid + '.full', value: data.full })
          this.editInput({ field: fid + '.pv', value: data.pv })
          this.editInput({ field: fid + '.url', value: api + 'static/' + sid + '/' + data.full })
          this.editInput({ field: fid + '.pvUrl', value: api + 'static/' + sid + '/' + data.pv })
          this.bimPlace[page] = api + 'static/' + sid + '/' + data.pv
          this.update++
          this.$message('info', 'Sikeres kép feltöltés')
        })
        .catch((error) => {
          this.$message('error', 'Kép feltöltés sikertelen')
          this.bimPlace[page] = false
          console.error(error);
        })
    },
    async fileUpload(fid, page, e) {
      let fileList = e.target.files
      let fileCount = fileList.length
      if (!fileCount) {
        return
      }
      const formData = new FormData()
      Array.from(Array(fileList.length).keys()).map((i) => {
        formData.append('file', fileList[i], fileList[i].name)
      })
      let sid = this.editValue('sid')
      if (sid) {
        formData.append('sid', this.record.sid)
      }
      let api = this.$config.api.cloud
      this.futch(
        api + 'file/upload',
        {
          method: 'POST',
          body: formData,
        },

        (prg) => {
        }

      )
        .then((data) => {
          let sid = this.editValue('sid')
          if (!sid) {
            this.editInput({ field: 'sid', value: data.sid })
            sid = data.sid
          }

          console.log("UPLOADED FILE DATA:", data)

          this.editInput({ field: fid + '.name', value: data.name })
          this.editInput({ field: fid + '.url', value: api + 'static/' + sid + '/' + data.name })
          this.editInput({ field: fid + '.sid', value: data.sid })
          this.editInput({ field: fid + '.size', value: data.size })
          this.bimPlace[page] = api + 'static/' + sid + '/' + data.name

          this.update++
          this.$message('info', 'Sikeres fájl feltöltés')
        })
        .catch((error) => {
          this.$message('error', 'Fájl feltöltés sikertelen')
          this.bimPlace[page] = false
          console.error(error);
        })
    },
    async beforeSubmit() {
      if (this.table == 'users') {
        let email = this.modify['email']
        if (this.modify['email']) {
          email = email.trim()
          if (!this.$validEmail(email)) {
            this.$message('error', `Hibás email formátum! '${email}'`)
            return false
          }
          const res = await this.$store.API('admin/list', {
            table: 'users',
            projection: {name: 1, phone: 1},
            filter: {email: email},
            limit: 1
          })
          if (res && res.list && res.list.length > 0) {
            let u = res.list[0]
            if (u._id != this.record._id) {
              this.$message('error', `ezzel az email címmel található másik felhasználó! '${email}'`)
              return false
            }
            console.log('found same user with email', u)
          } else {
            console.log('user not found with email')
          }
        }
        let uset = {}
        for (let key in this.modify) {
          if (key && key != 'undefined') {
            let value = (''+this.modify[key]).trim()
            uset['user.' + key] = value
            uset['contact_' + key] = value
          }
        }
        for (let mtable of ['orders','saves']) {
          let data = {
            table: mtable,
            filter: {
              'user.email' : this.record['email'],
            },
            set: uset
          }
          const res = await this.$store.API('admin/update', data)
          if (!res) {
            this.$message('error', `Művelet sikertelen! [beforeSubmit ${mtable}]`)
          } else {
            console.log(`Művelet sikeres [beforeSubmit ${mtable}]`, res, data)
          }
        }
      }
      return true
    },
    async submit() {
      this.loading = true
      await this.checkRequote()
      for (let key in this.modify) {
        if (this.isNumber[key]) {
          this.modify[key] = parseFloat(this.modify[key])
        }
      }
      let doit = await this.beforeSubmit()
      if (!doit) { this.loading = false; return; }
      let data = {
        table: this.table,
        filter: {
          _id: this.$route.params.id,
        },
        set: this.modify
      }
      const res = await this.$store.API('admin/update', data)
      if (res) {
        this.$message('info', this.$schema[this.table].title_single + ' ' + this.record[this.$schema[this.table].list_field] + ' módosítva.')
        this.modify = {}
        this.$router.push('/list/' + this.table + '/#scroll-' + this.$route.params.id)
      } else {
        this.$message('error', 'Művelet sikertelen!')
      }
      this.update++
    },
  },
}
</script>

<style>
input[disabled] {
  background: #eee;
  color: #444;
}
</style>
